module.exports = __webpack_public_path__ + "static/media/oyster-mushroom.9c116460.png";